// extracted by mini-css-extract-plugin
export default {"sidebar":"MobileSideBar_sidebar__V4eGv","expandSidebar":"MobileSideBar_expandSidebar__oL3e6"};